import { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { useNavigate } from "react-router-dom";

const UGCLondon = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate("/");
    }, 100);
    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <>
      <Helmet>
        <title>UGC Agency London | AI UGC Creator UK | Fuel72</title>
        <meta
          name="description"
          content="UGC Agency London: Professional AI UGC videos for UK businesses. UGC Creator London without influencers. 72-hour delivery. ✓ Local ✓ Fast ✓ Affordable"
        />
        <meta
          name="keywords"
          content="ugc agency london, ugc creator uk, ugc london, ai ugc uk, ugc videos london, content creator london, ugc advertising uk"
        />
        <link rel="canonical" href="https://www.fuel72.com/ugc-london" />
        
        <link rel="alternate" hrefLang="en" href="https://www.fuel72.com/ugc-london" />
        <link rel="alternate" hrefLang="en-GB" href="https://www.fuel72.com/ugc-london" />
        <link rel="alternate" hrefLang="x-default" href="https://www.fuel72.com/ugc-london" />
        
        <meta property="og:title" content="UGC Agency London | AI UGC Creator UK | Fuel72" />
        <meta property="og:description" content="AI UGC videos for UK businesses. Fast, professional, affordable." />
        <meta property="og:url" content="https://www.fuel72.com/ugc-london" />
        <meta property="og:locale" content="en_GB" />
        
        <meta name="geo.region" content="GB-LND" />
        <meta name="geo.placename" content="London" />
        <meta name="geo.position" content="51.5074;-0.1278" />
        <meta name="ICBM" content="51.5074, -0.1278" />

        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "LocalBusiness",
            "name": "Fuel72 - UGC Agency London",
            "description": "Professional AI UGC videos for London and UK businesses. Create UGC content without filming.",
            "url": "https://www.fuel72.com/ugc-london",
            "telephone": "+4917687870011",
            "email": "hello@fuel72.com",
            "address": {
              "@type": "PostalAddress",
              "addressLocality": "London",
              "addressCountry": "GB"
            },
            "geo": {
              "@type": "GeoCoordinates",
              "latitude": "51.5074",
              "longitude": "-0.1278"
            },
            "areaServed": { "@type": "City", "name": "London" },
            "priceRange": "££"
          })}
        </script>
      </Helmet>

      <main className="min-h-screen gradient-mesh flex items-center justify-center">
        <div className="container mx-auto px-4 py-20 text-center">
          <h1 className="text-4xl md:text-6xl font-heading font-bold mb-6">
            UGC Agency{" "}
            <span className="bg-gradient-to-r from-neon-purple via-neon-pink to-orange-500 bg-clip-text text-transparent">
              London
            </span>
          </h1>
          <p className="text-xl text-muted-foreground max-w-2xl mx-auto mb-8">
            Professional AI UGC videos for UK businesses. 
            Retail, hospitality, startups – we make you visible.
          </p>
          
          <div className="max-w-3xl mx-auto text-left space-y-6">
            <h2 className="text-2xl font-bold">UGC for London Businesses</h2>
            <p className="text-muted-foreground">
              London is Europe's business hub. With Fuel72, UK businesses get professional 
              UGC videos that perform on Instagram, TikTok and Meta Ads – without expensive 
              London-based creators.
            </p>
            
            <h2 className="text-2xl font-bold mt-8">Industries in London</h2>
            <ul className="space-y-2 text-muted-foreground">
              <li>🏦 Finance & Fintech</li>
              <li>🛍️ Retail & E-Commerce</li>
              <li>🍔 Restaurants & Hospitality</li>
              <li>💪 Fitness & Wellness</li>
              <li>💇 Beauty & Fashion</li>
              <li>🚀 Tech Startups</li>
            </ul>
            
            <h2 className="text-2xl font-bold mt-8">Why Fuel72 for London?</h2>
            <ul className="space-y-3 text-muted-foreground">
              <li>✅ <strong>Cheaper</strong> – £249 instead of £400-1500 per creator</li>
              <li>✅ <strong>Faster</strong> – 72 hours instead of weeks</li>
              <li>✅ <strong>Scalable</strong> – Unlimited content production</li>
              <li>✅ <strong>No risk</strong> – Consistent quality every time</li>
            </ul>
          </div>
          
          <p className="text-sm text-muted-foreground mt-12">Redirecting to main page...</p>
        </div>
      </main>
    </>
  );
};

export default UGCLondon;